import React from 'react'
import { IMicroActivityBlockStoryFormProps } from './MicroActivityBlockStoryForm.interface'
import { Field } from 'redux-form/immutable'
import Text from 'app/components/Text'
import TextArea from 'app/components/TextArea'

import './styles.scss'

const bc = 'micro-activity-block-story-form'

const MicroActivityBlockStoryForm: React.FC<IMicroActivityBlockStoryFormProps> = ({ input, t }) => {
  return (
    <form>
      <Field
        {...input}
        name="story"
        component={TextArea}
        placeholder={t('Please write here')}
        maxCharacters={400}
        availableMentionOptions
      />
      <Text htmlTag="p" customTitleClass={`${bc}__message`} isSubtitle>
        {t('You can tag someone in the story using “@“ before name')}
      </Text>
    </form>
  )
}

export default MicroActivityBlockStoryForm
